<template>
    <div>
        <h6 class="heading-small text-muted mb-4">Import Options</h6>
        <div>
            <a-upload-dragger :remove="handleRemove" :fileList="fileList" :beforeUpload="beforeUpload"
                :multiple="false">
                <span class="fa fa-file-import" style="font: 20pt;" />
                <p class="ant-upload-text">Click or drag file to this area to upload</p>
                <p class="ant-upload-hint">
                    Upload your {{_.singularize(currentProfile)}} list in a CSV file following the specified format. You can download download
                    templates below.
                </p>
            </a-upload-dragger>

            <br><br>
            <a-collapse activeKey="1">
                <a-collapse-panel header="Templates" key="1">
                    <a-list bordered>
                        <a-list-item>
                            <a-list-item-meta :description="'Contains required data to create a ' + _.startCase(_.singularize(currentProfile))">
                                <a @click.prevent="downloadTemplate('1')" slot="title">Download Basic {{_.startCase(_.singularize(currentProfile))}}
                                    Template</a>
                            </a-list-item-meta>
                            <div>
                                <a @click.prevent="downloadTemplate('1')"><span class="fa fa-file-download" /></a>
                            </div>
                        </a-list-item>
                        <a-list-item v-if="currentProfile == 'customers'">
                            <a-list-item-meta :description="'[Advanced] Contains required data to create a ' + _.startCase(_.singularize(currentProfile))">
                                <a @click.prevent="downloadTemplate('3')" slot="title">Download Advance {{_.startCase(_.singularize(currentProfile))}}
                                    Template</a>
                            </a-list-item-meta>
                            <div>
                                <a @click.prevent="downloadTemplate('3')"><span class="fa fa-file-download" /></a>
                            </div>
                        </a-list-item>
                    </a-list>
                </a-collapse-panel>
            </a-collapse>
        </div>
        
        <div
            style="position: absolute;bottom: 0px;right: 0px;width: -webkit-fill-available;background-color: #f2f2f2 ;padding: 10px;">
            <a-spin :spinning="loading">
            <button type="button" class="btn btn-primary float-right" @click.prevent="importFile">Import</button>
        </a-spin>
        </div>
    </div>
</template>

<script>
    import HTTPRequest from '../controllers/httpRequest'
    import secureStorage from '../controllers/secureStorage';
    import axios from "axios";
    import {
        mapState,
        mapActions
    } from 'vuex'

    var component_x
    export default {
        data: function () {
            return {
                fileList: [],
                product_id: 0,
                loading: false
            }
        },
        mounted: async function () {
            component_x = this
        },
        computed: {
            ...mapState(['currentProfile', 'currentApiURL', 'endPoint', 'parameters']),
        },
        methods: {
            ...mapActions(['updateCurrentProfile', 'updateParameters']),
            beforeUpload(file) {
                this.fileList = [...this.fileList, file];
                return false;
            },
            downloadTemplate(type) {
                var urlDownload;
                if (type == "1")
                    urlDownload = this.endPoint + "import_templates/download_file?profile_name=" + this.currentProfile + "&type=basic"
                else if (type == "3")
                    urlDownload = this.endPoint + "import_templates/download_file?profile_name=" + this.currentProfile + "&type=advance_customer"
                else
                    urlDownload = this.endPoint + "import_templates/download_file?profile_name=" + this.currentProfile + "&type=advanced"

                axios({
                    url: urlDownload,
                    method: 'POST',
                    responseType: 'blob', // important
                    headers: {
                        Authorization: 'Bearer ' + secureStorage.getItem("accessToken"),
                        "Access-Control-Allow-Origin": "*", 'Request-Source':"BXI-File", 'ip':secureStorage.getItem("ipAddress")
                    }
                }).then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', _.singularize(component_x.currentProfile) + '_import_template.csv');
                    document.body.appendChild(link);
                    link.click();
                    component_x.$notification['success']({
                        message: 'Successful Download',
                        description: "You have succesfully downloaded the template for " + _.singularize(component_x.currentProfile) + " upload."
                    });
                });
            },
            handleRemove(file) {
                const index = this.fileList.indexOf(file);
                const newFileList = this.fileList.slice();
                newFileList.splice(index, 1);
                this.fileList = newFileList;
            },
            async importFile() {
                this.loading = true;
                if(component_x.currentProfile == 'gift_certificates')
                    component_x.product_id = component_x.$attrs.product_id

                let formData = new FormData();
                formData.append('profile_name', component_x.currentProfile);
                formData.append('file', this.fileList[0]);

                if(this.fileList[0] == '' || this.fileList[0] === undefined)
                    this.loading = false;

                await axios({
                    method: 'post',
                    url: this.endPoint + 'importers/upload_file',
                    headers: {
                        Authorization: 'Bearer ' + secureStorage.getItem("accessToken"),
                        "Access-Control-Allow-Origin": "*", 'Request-Source':"BXI-File", 'ip':secureStorage.getItem("ipAddress")
                    },
                    data: formData,
                })
                .then(async function (m) {
                    var payload = {
                        import_job: {
                            profile_name: component_x.currentProfile,
                            file_name: m.data.file_name
                        }
                    }
                    var response = await HTTPRequest.postRequest(component_x.endPoint + "/import_jobs?product_id="+component_x.product_id, null, payload)
                    console.log(response)
                    if (response.id != null) { 
                        component_x.$notification['success']({
                            message: 'Successful Operation',
                            description: "File has been uploaded. Your importation is ongoing, you can check the ongoing jobs for updates.",
                            btn: h => {
                                return h(
                                    'base-button', {
                                        props: {
                                            type: 'primary',
                                            class: 'btn-sm',
                                        },
                                        on: {
                                            click: () => component_x.$router.push("/jobs"),
                                        },
                                    },
                                    'View Jobs',
                                );
                            },
                        });
                        component_x.$emit("closeDrawer")
                    }
                });
                this.loading = false;
            },
        }
    };
</script>

<style></style>
